import React from 'react';
import ReactDOM from 'react-dom';

import {BrowserRouter as Router} from 'react-router-dom';
import {IntlProvider, addLocaleData} from 'react-intl';
import App from './components/App';
import '../semantic/dist/semantic.css';
import './styles/index.css';

import it from 'react-intl/locale-data/it';

addLocaleData([...it]);

ReactDOM.render(
    <IntlProvider locale="it-IT">
        <Router>
            <App />
        </Router>
    </IntlProvider>,

  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/